<svelte:options accessors/>
<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import NauiSelect from "../../naui/atoms/NauiSelect.svelte";
    import DocumentTable from "../../common/DocumentTable.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiFloatingAction from "../../naui/components/NauiFloatingAction.svelte";
    import NauiDatePicker from "../../naui/atoms/NauiDatePicker.svelte";
    import NauiCheckbox from "../../naui/atoms/NauiCheckbox.svelte";

    export let data: any;
    export let options: Array<any>;
    export let status: number;
    export let reserveStatus: 'available' | 'reserved' | 'occupied';

    let files = [];
    let dispatch = createEventDispatcher();

    function saveData(report = false) {
        let valid = true;
        if (reserveStatus === 'available') {
            dispatch('save', {status});
        } else {
            if (report) {
                if (!data.entry_date) {
                    alert('Se debe ingresar la fecha de ingreso.');
                    valid = false;
                }
                if (reserveStatus === 'occupied') {
                    if (!data.exit.date) {
                        alert('Se debe ingresar la fecha de salida.');
                        valid = false;
                    }
                    // TODO flujo paz y salvo
                    /*if (!data.documentos.find(d => d.slug === 'paz-y-salvo').route) {
                        alert('Se debe subir el paz y salvo.');
                        valid = false;
                    }*/
                }
            }
            if (valid) {
                dispatch('save', {data, report});
            }
        }
    }

    function changeFile(ev) {
        dispatch('upload', ev.detail);
    }

    function removeFile(ev) {
        const doc = data.documentos.find(e => e.slug === ev.detail.slug);
        if (confirm(`¿Desea eliminar el archivo "${doc.label}"?`)) {
            dispatch('delete-file', ev.detail);
        }
    }
</script>
<div>
    <fieldset class="mt-2 mb-0">
        <legend>Información de ocupación</legend>
        {#if data}
            <div class="grid-3-1">
                <div class="grid-3 gap-15">
                    <NauiSelect label="Asesor" bind:value={data.asesor} options="{options.asesores}"/>
                    <NauiSelect label="Cliente" bind:value={data.cliente} options="{options.clientes}"/>
                    <NauiInput label="No. Solicitud" bind:value={data.num_solicitud}/>
                    <NauiSelect label="Persona" bind:value={data.tipo_persona} options="{options.tipos_persona}"/>
                    <NauiInput type="email" label="Correo" bind:value={data.email}/>
                    <NauiInput label="Teléfono" bind:value={data.telefono}/>
                    {#if reserveStatus === 'reserved' || data.entry_date === ''}
                        <NauiDatePicker label="Fecha de ingreso" bind:value={data.entry_date}/>
                        {#if reserveStatus === 'occupied'}
                            <p class="pt-iii">* No se registra la fecha de ingreso de la bodega.</p>
                        {/if}
                    {/if}
                </div>
            </div>
            {#if reserveStatus === 'occupied'}
                <hr class="my-1">
                <div class="grid-3 gap-15">
                    <NauiDatePicker label="Fecha de salida" bind:value={data.exit.date}/>
                </div>
                <div class="grid-1 max-w-400px my-1">
                    {#each data.exit.reasons as opt}
                        <NauiCheckbox label={opt.label} bind:value={opt.selected}/>
                    {/each}
                </div>
            {/if}
            <div class="box-r">
                {#if reserveStatus === 'reserved'}
                    <NauiButton caption="REPORTAR INGRESO" mode="outline" color="accent"
                                on:click={() => {saveData(true)}}/>
                {:else if reserveStatus === 'occupied'}
                    <NauiButton caption="REPORTAR SALIDA" mode="outline" color="accent"
                                on:click={() => {saveData(true)}}/>
                {/if}
            </div>
        {:else}

            <div class="grid-3 ga-1">
                <NauiSelect label="Estado" bind:value={status} options="{options.status}"/>
            </div>
        {/if}
    </fieldset>

    {#if data}
        <fieldset>
            <legend>Documentos</legend>
            <div class="max-w-800px">
                <DocumentTable data={data.documentos} checkbox={false} on:file={changeFile} on:action={removeFile}/>
            </div>
        </fieldset>
    {/if}
    <NauiFloatingAction>
        <NauiButton caption="GUARDAR"
                    icon="save"
                    color="accent"
                    mode="solid"
                    type="submit"
                    on:click={() => {saveData(false)}}/>
    </NauiFloatingAction>
</div>